<template>
  <div>
    <b-alert
      v-model="showAlert"
      variant="success"
      class="encouragement-alert"
    >
      <i class="icon">
        <icon-check-alternative />
      </i>
      {{ message }}
    </b-alert>
  </div>
</template>

<script>
import { trackingParamsList, pidList } from 'config/trackingParams';
import { BAlert } from 'bootstrap-vue';
import IconCheckAlternative from 'ICON:IconCheckAlternative';

export default {
  name: 'EncouragementAlert',
  components: {
    BAlert,
    IconCheckAlternative,
  },
  props: {
    objectNumber: {
      required: true,
      type: [Number, String],
    },
    message: {
      required: true,
      type: String,
    },
  },
  computed: {
    showAlert() {
      // only check == because objectNumber is sometimes string and sometimes number...
      // eslint-disable-next-line eqeqeq
      return this.$store.getters.getEncouragementFlag == this.objectNumber;
    },
  },
  mounted() {
    // console.log(this.$route.query);
    this.saveEncouragementFlag();
  },
  methods: {
    saveEncouragementFlag() {
      // check if url has get param with valid pid
      Object.keys(this.$route.query).forEach((paramKey) => {
        Object.keys(trackingParamsList).forEach((trackingParam) => {
          // must match case insensitive
          if (trackingParam.toLowerCase() === paramKey.toLowerCase()) {
            if (trackingParamsList[paramKey.toLowerCase()]?.isPid === true) {
              const pidParam = this.$route.query[paramKey];
              if (pidList[pidParam]?.encouragementAlert === true) {
                this.$store.dispatch('SAVE_ENCOURAGEMENT_FLAG', {
                  objectNumber: this.objectNumber,
                });
              }
            }
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.encouragement-alert {
  .icon {
    margin-bottom: 0;
  }
}
</style>
